import React, {useState, useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import {SystemSettingsGetSchema} from '../../../../api/DBSchema/SystemSettings';
import Sepperator from '../../../../components/Simple/Sepperator';
import SMCButton from '../../../../components/Simple/SMCButton';
import {useSMCErrorHandler} from '../../../../utils/errorUtils';
import Api from '../../../../api/SMPFetchHelper';
import RowLayout from '../../../../components/Layouts/RowLayout';

const pageSchema = SystemSettingsGetSchema.pages.overview;

/**
 * TODO: Make this fetch data from a sepperate endpoint, and remove this from the systemSettingsObject.
 * Reasons:
 *  - This pages data is heavy to retrieve, dont retrieve if not used.
 *  - Will allow a refresh button
 */
function SystemSettingsOverview() {
    const { t } = useTranslation();
    const { getErrorMessage } = useSMCErrorHandler();

    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);

    const connectedGatewaysNum    = pageData ? pageData[pageSchema.connectedGatewaysNum]    : null;
    const disconnectedGatewaysNum = pageData ? pageData[pageSchema.disconnectedGatewaysNum] : null;
    const disabledGatewaysNum     = pageData ? pageData[pageSchema.disabledGatewaysNum]     : null;
    const activePortalsNum        = pageData ? pageData[pageSchema.activePortalsNum]        : null;
    const disabledPortalsNum      = pageData ? pageData[pageSchema.disabledPortalsNum]      : null;
    const loggedInUsersNum        = pageData ? pageData[pageSchema.loggedInUsersNum]        : null;

    const reloadPageData = useCallback(() => {
        setIsLoading(true);
        Api.getSystemOverviewData()
        .then(resp => {
            setPageData(resp.data.data);
        })
        .catch(e => {
            const errorMessage = getErrorMessage(e);
            alert(errorMessage);
        })
        .finally(() => {
            setIsLoading(false);
        });
    }, [getErrorMessage]);

    return (
        <EditorLayout>
            {
                !pageData && (
                    <RowLayout>
                        <SMCButton ignoreDisabledContext onClick={reloadPageData} disabled={isLoading}>
                            {t('SMP.SETTINGS.OVERVIEW.LOAD_DATA')}
                        </SMCButton>
                    </RowLayout>
                )
            }
            {
                pageData && (
                    <>
                        <SMCTextInput
                            readOnly
                            value={connectedGatewaysNum}
                            label={t('SMP.SETTINGS.OVERVIEW.CONNECTED_GW')}
                        />
                        <SMCTextInput
                            readOnly
                            value={disconnectedGatewaysNum}
                            label={t('SMP.SETTINGS.OVERVIEW.DISCONNECTED_GW')}
                        />
                        <SMCTextInput
                            readOnly
                            value={disabledGatewaysNum}
                            label={t('SMP.SETTINGS.OVERVIEW.DISABLED_GW')}
                        />
                        <Sepperator />
                        <SMCTextInput
                            readOnly
                            value={activePortalsNum}
                            label={t('SMP.SETTINGS.OVERVIEW.ACTIVE_SERVICE_DOMAINS')}
                        />
                        <SMCTextInput
                            readOnly
                            value={disabledPortalsNum}
                            label={t('SMP.SETTINGS.OVERVIEW.DISABBLED_SERVICE_DOMAINS')}
                        />
                        <SMCTextInput
                            readOnly
                            value={loggedInUsersNum}
                            label={t('SMP.SETTINGS.OVERVIEW.LOGGED_IN_USERS')}
                        />
                        <SMCButton onClick={reloadPageData} disabled={isLoading}>
                            {t('SMP.SETTINGS.OVERVIEW.REFRESH')}
                        </SMCButton>
                    </>
                )
            }
        </EditorLayout>
    )
}

export default SystemSettingsOverview;